import { useLocation, useParams } from "react-router-dom";
import useFetchMsal from "../../Common/UI/hooks/useFetchMsal";
import { useEffect, useState } from "react";
import SNEvent from "./interfaces/SNEvent";
import { config } from "../../authConfig";
import HorizontalLinearStepper from "./HorizontalLinearStepper";
import { Box } from "@mui/material";
import { LoadingIndicator } from "../../Common/UI/controls/LoadingIndicator";

export default function EventJourney() {
  const { eventId } = useParams();
  const location = useLocation();
  const execute = useFetchMsal();
  const [event, setEvent] = useState<SNEvent>({});
  const [loading, setLoading] = useState<boolean>(false);

  const fetchEvent = async () => {
    try {
      setLoading(true);
      const url = config.rootAPIList?.event.replace("{id}", eventId!);
      const response = await execute("GET", `${config.rootAPIUrl}${url}`);
      if (response !== undefined) {
        setEvent(response);
      }
    } catch (error: any) {
      console.error(error);
      throw new Error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!location.state) {
      fetchEvent();
    } else if (location.state) {
      setEvent(location.state as SNEvent);
    }
  }, [location.state]);

  return (
    <Box sx={{ mx: 3 }}>
      {" "}
      <LoadingIndicator show={loading}>
        <HorizontalLinearStepper event={event} setEvent={setEvent} />
      </LoadingIndicator>
    </Box>
  );
}
